import { render, staticRenderFns } from "./AddCustom.vue?vue&type=template&id=4d216710&scoped=true&"
import script from "./AddCustom.vue?vue&type=script&lang=js&"
export * from "./AddCustom.vue?vue&type=script&lang=js&"
import style0 from "./AddCustom.vue?vue&type=style&index=0&id=4d216710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d216710",
  null
  
)

export default component.exports